module.exports = __webpack_public_path__ + "static/media/reduniqLogo.84c97362.jfif";